import { createCustomSelector } from '../../../domain/utils/react-reselect'
import { selectSearchState } from '../search.selectors'
import { lastTenHistoryEntries } from './searchHistory.utils'

export const selectSearchHistory = createCustomSelector(selectSearchState, search => search?.searchHistory ?? [])

export const selectLastTenHistoryEntries = createCustomSelector(selectSearchHistory, searchHistory =>
  lastTenHistoryEntries(searchHistory)
)
